module.exports = {
	"id": "/time"
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/time.json
 ** module id = 1833
 ** module chunks = 0
 **/